<template>

    <div class="TQ_text_20px" >


        <div class="TQ_bg_gold_w TQ_padding_8px" v-if="questEvent_currentStatus_e === enum_eventCurrentStatus.didntStart" >
            <div> {{ass_strings.threeWords_questDidntStart[p_system_langCode_e]}}</div>
        </div>

        <div class="TQ_bg_gold_w TQ_padding_8px" v-else-if="questEvent_currentStatus_e === enum_eventCurrentStatus.waiting" >
            <div> {{ass_strings.threeWords_questStringIn[p_system_langCode_e]}}</div>
            <div class="TQ_text_24px"> {{format_duration_hhmmss(questEvent_millisecondsTo_statingEvent_n, p_system_langCode_e)}}</div>
        </div>

        <div class="TQ_bg_green TQ_padding_8px" v-else-if="questEvent_currentStatus_e === enum_eventCurrentStatus.ongoing">
            <div> {{ass_strings.twoWords_questStarted[p_system_langCode_e]}}</div>
            <div class="TQ_margin_top_4px"> {{format_duration_hhmmss(questEvent_millisecondsTo_endingEvent_n, p_system_langCode_e)}}</div>
        </div>

        <div class="TQ_bg_red TQ_padding_8px" v-else-if="questEvent_currentStatus_e === enum_eventCurrentStatus.finish">
            <div> {{ass_strings.twoWords_questFinish[p_system_langCode_e]}}</div>
        </div>

    </div>
</template>

<script>
    import {enum_questEventStatus} from "../../../functions/src/shareCode/Share_S_Enum";
    import {validator_enum_fb} from "../../../functions/src/shareCode/Share_S_Validator";
    import {format_duration_hhmmss} from "../../../functions/src/shareCode/Share_S_Format";
    import {ass_strings} from "../../../functions/src/shareCode/Share_Ass_Dictionary";
    import {date_doEveryClockTick_addCb_f, date_doEveryClockTick_removeCb_f} from "../../scripts/S_Date";
    import {FB_GameStatus, FB_QuestBody, FB_QuestEvent} from "../../../functions/src/shareCode/Share_S_Classes";
    import {enum_langCodes} from "../../../functions/src/shareCode/Share_S_Enum";
    import {
        helper_getEventClockStatus_e,
        helper_millSecToEndingQuest_n,
        helper_millSecToStartingQuest_t
    } from "../../scripts/S_Helper";

    export default {
        name: "TqEventStatusBar",
        props:{
            p_uid_s:{
                type: String,
                require: true
            },

            p_questEvent_c:{
                type: FB_QuestEvent,
                require:true,
            },
            p_gameStatus_c:{
                type: FB_GameStatus,
                require:true,
            },
            p_questBody_c : {
                type: FB_QuestBody,
                require:true,
            },
            p_currentTeamId_uid:{
                type: String,
                require:true,
            },


            p_system_langCode_e:{
                type: String,
                require:true,
                validator(val){
                    return validator_enum_fb(enum_langCodes, val)
                }
            }
        },
        data(){
            return {
                format_duration_hhmmss  : format_duration_hhmmss,
                enum_eventCurrentStatus     : enum_questEventStatus,
                ass_strings                 : ass_strings,

                questEvent_currentStatus_e: null,
                questEvent_millisecondsTo_statingEvent_n: -1,
                questEvent_millisecondsTo_endingEvent_n: -1,
            }
        },
        created(){

            // 4) set clock
            date_doEveryClockTick_addCb_f(this.p_uid_s + this.p_currentTeamId_uid, () => {

                this.questEvent_millisecondsTo_statingEvent_n = helper_millSecToStartingQuest_t(this.p_questEvent_c, this.p_gameStatus_c, this.p_currentTeamId_uid)
                this.questEvent_millisecondsTo_endingEvent_n = helper_millSecToEndingQuest_n(this.questEvent_millisecondsTo_statingEvent_n, this.p_questEvent_c,this.p_gameStatus_c)

                this.questEvent_currentStatus_e = helper_getEventClockStatus_e(this.questEvent_millisecondsTo_statingEvent_n, this.questEvent_millisecondsTo_endingEvent_n)
            }, true)

        },
        destroyed(){
            // 3) stop clock
            date_doEveryClockTick_removeCb_f(this.p_uid_s + this.p_currentTeamId_uid)
        }
    }
</script>

<style scoped>






</style>